import { Component, OnInit } from '@angular/core';
import {FormBuilder, FormGroup, UntypedFormGroup, Validators} from "@angular/forms";
import {AuthenticationService} from "../services/authentication.service";
import {Router} from "@angular/router";

@Component({
    selector: 'app-register-organization',
    templateUrl: './register-organization.component.html',
    styleUrls: ['./register-organization.component.css'],
    standalone: false
})
export class RegisterOrganizationComponent implements OnInit {
  credentialForm = new UntypedFormGroup({});
  constructor(
    private fb: FormBuilder,
    private authService: AuthenticationService,
    private router: Router
  ) {
    this.authService.redirectLoggedInUser();
  }

  ngOnInit(): void {
    this.credentialForm = this.fb.group({
      organization: ['', [Validators.required]],
      address: ['', [Validators.required, Validators.minLength(10)]],
      contactName: ['', [Validators.required]],
      contactPhone: ['', [Validators.required, Validators.minLength(10)]],
      email: ['', [Validators.required, Validators.email]],
      password: ['', [Validators.required, Validators.minLength(6)]]
    });
  }

  async signUp() {
    if(!this.credentialForm.valid) {
      return;
    }

    this.authService
      .signUpOrganization(this.credentialForm.value)
      .then(
        (userID) => {
          this.router.navigateByUrl('/', { replaceUrl: true });
        },
        async (err) => {}
      );
  }

  signOut() {
    this.authService.signOut();
  }

  get organization() {
    return this.credentialForm.get('organization');
  }

  get address() {
    return this.credentialForm.get('address');
  }

  get contactName() {
    return this.credentialForm.get('contactName');
  }

  get contactPhone() {
    return this.credentialForm.get('contactPhone');
  }

  get email() {
    return this.credentialForm.get('email');
  }

  get password() {
    return this.credentialForm.get('password');
  }
}
